export class ChargeTypeUnit {
    id = null;

    description = '';
}
